import { createAsyncThunk } from '@reduxjs/toolkit';

import * as livekit from 'endpoints/live-kit';
import { ApiResponse } from 'endpoints/endpoint';
import { apiRequest } from 'client/utils';

export const startBroadcast = createAsyncThunk<
  ApiResponse<livekit.CreateRoomResult, livekit.CreateRoomError>,
  livekit.CreateRoomParams,
  { rejectValue: string }
>('livekit/startBroadcast', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest<livekit.CreateRoomParams, livekit.CreateRoomResult, livekit.CreateRoomError>(
      livekit.createRoom,
      {
        retries: true,
        data,
      },
    )();

    if (response.success) {
      return response;
    }

    throw new Error('StartBroadcastError');
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
